module.exports = __webpack_public_path__ + "static/tg_mini-cde5463cc52e8235f020c90013b8a13b.png";